import { getAccessToken } from "@/auth/tokenHandler";

export const getHeaders = async (
  token: string | null = null,
): Promise<Record<string, string> | undefined> => {
  try {
    const accessToken = token ?? (await getAccessToken());
    if (!accessToken) return undefined;

    return {
      Authorization: `Bearer ${accessToken}`,
    };
  } catch (error) {
    console.log(error);
    return undefined;
  }
};
